import React, { useState, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useStore } from '@/models';
import cx from 'classnames';
import cs from './index.module.scss';
import Menu from './menu';
import Profile from './profile';
import Logo from './logo';
import Setting from './setting';
import Notice from './notice';
import Order from './order';
import Assets from './assets';
import Sign from './sign';

interface Props {
  transparent?: boolean;
}

const HomeHeader: React.FC<Props> = ({ transparent }) => {
  const location = useLocation();
  const [showFixedHeader, setShowFixedHeader] = useState(true);
  const lastScrollYRef = useRef(0);

  // 判断是否在合约或现货页面
  const isTradingPage = /^(\/futures\/contract\/)/.test(location.pathname) || /^(\/spot\/trade\/)/.test(location.pathname);

  // 判断是否在首页
  const isHomePage = location.pathname === '/' || location.pathname === '/home';
  // 动态固定header
  // useEffect(() => {
  //   if (!isHomePage) {
  //     setShowFixedHeader(false);
  //     lastScrollYRef.current = 0;
  //     return;
  //   }

  //   // 初始化滚动位置
  //   const initialScrollY = window.scrollY;
  //   lastScrollYRef.current = initialScrollY;

  //   // 如果初始就在滚动位置，根据位置决定是否显示
  //   // if (initialScrollY > 0) {
  //   //   setShowFixedHeader(true);

  //   // }
  //   const handleScroll = () => {
  //     const currentScrollY = window.scrollY;
  //     const scrollDelta = currentScrollY - lastScrollYRef.current;

  //     // 在顶部时，隐藏固定 header
  //     if (currentScrollY <= 0) {
  //       setShowFixedHeader(true);
  //     } else {
  //       // 判断滚动方向
  //       if (scrollDelta < 0) {
  //         // 向上滚动：显示固定 header
  //         setShowFixedHeader(true);
  //       } else if (scrollDelta > 0) {
  //         // 向下滚动：隐藏固定 header（不做任何固定效果）
  //         setShowFixedHeader(false);
  //       }
  //       // scrollDelta === 0 时保持当前状态
  //     }

  //     lastScrollYRef.current = currentScrollY;
  //   };

  //   window.addEventListener('scroll', handleScroll, { passive: true });

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, [isHomePage]);

  // 只在首页时渲染
  if (!isHomePage) {
    return null;
  }

  return (
    <>
      <header
        className={cx(
          cs.header,
          cs.headerHome,
          cs.fixed,
          transparent ? cs.transparent : '',
          isTradingPage ? cs.whiteBg : '',
          !showFixedHeader ? cs.hidden : '',
        )}
      >
        <div className={cx(cs.headerInner)}>
          <div className={cs.headerGroup}>
            <Logo />
            <Menu />
          </div>

          <div className={cs.headerGroup}>
            <Sign />
            <Setting />
            <Profile />
          </div>
        </div>
      </header>
    </>
  );
};

export default observer(HomeHeader);
